import { Dialog } from "@mui/material";
import React from "react";
import { Button } from "../ui";
import { InlineLoader } from "../Loader";

const ConfirmationModal = ({
  isOpen,
  onClose,
  title,
  description,
  confirmButtonLabel,
  onConfirm,
  isLoading = false,
  loadingMessage = "Loading...",
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <div className="p-4">
        <h2 className="font-semibold text-xl">{title}</h2>
        <p className="text-neutral mt-3">{description}</p>
        <div className="flex items-center justify-center space-x-5 mt-6">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="default"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading && <InlineLoader className="text-white mr-2" />}
            {isLoading ? loadingMessage : confirmButtonLabel}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmationModal;
